export default __webpack_public_path__ + "static/media/PF_05.99ba9ba7.png";